/**
 * @generated SignedSource<<d36209899006d6a4f1406296d64e2e42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutSetUpActionsSetUpPanes_preCheckoutTransaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutPaneReducer_preCheckoutTransaction">;
  readonly " $fragmentType": "checkoutSetUpActionsSetUpPanes_preCheckoutTransaction";
};
export type checkoutSetUpActionsSetUpPanes_preCheckoutTransaction$key = {
  readonly " $data"?: checkoutSetUpActionsSetUpPanes_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutSetUpActionsSetUpPanes_preCheckoutTransaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutSetUpActionsSetUpPanes_preCheckoutTransaction"
};

(node as any).hash = "5f7f108f0f9555e96d616d6121fcb588";

export default node;
